export function formatTime12(t) {
    if (!t) return '';
    const [h, m] = t.split(':').map(Number);
    if (isNaN(h)) return t;
    const ampm = h >= 12 ? 'PM' : 'AM';
    const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
    return m === 0 ? `${h12} ${ampm}` : `${h12}:${String(m).padStart(2, '0')} ${ampm}`;
}

// Truck double-booking check.
//
// SAME-LEAD RULE (Jaylen 2026-08-07): a truck on several same-day jobs
// that all belong to ONE crew lead is not a conflict — it's that lead's
// truck for the day, run job-to-job (Landon's five deliveries on one
// 16'). Time overlap can't distinguish this (small jobs share a morning
// time + the 4h default duration), so the crew chain is the signal:
// pass `leaderId` (the lead being assigned) and jobs led by the same
// person are skipped. Jobs with a DIFFERENT lead — or no lead yet, since
// ownership is unknowable — still conflict on time overlap, and the
// pickers surface those as a warn-and-confirm rather than a hard block
// (deliberate mid-day truck handoffs between crews are real).
export function getTruckConflicts(truckId, date, duration, time, currentJobId, allJobs, leaderId) {
    if (!date || !time) return null;
    const [h, m] = time.split(':').map(Number);
    const startMin = h * 60 + (m || 0);
    const endMin = startMin + (duration || 4) * 60;
    const conflicting = allJobs.filter(j => {
        if (j.id === currentJobId) return false;
        if (j.move_date !== date) return false;
        if (!(j.truck_ids || []).includes(truckId)) return false;
        if (leaderId && j.leader_id === leaderId) return false; // same crew chain — his truck for the day
        const [jh, jm] = (j.time || '08:00').split(':').map(Number);
        const jStart = jh * 60 + (jm || 0);
        const jEnd = jStart + (j.duration || 4) * 60;
        return startMin < jEnd && endMin > jStart;
    });
    return conflicting.length > 0 ? conflicting : null;
}
